"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentersQuoteSummaryPanelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var CommonRenderers_1 = require("../../../helpers/CommonRenderers");
var RentersPricingExplainedRenderers_1 = require("../../../components/modals/renderers/RentersPricingExplainedRenderers");
var RentersQuoteSummaryPanelWidget = exports.RentersQuoteSummaryPanelWidget = /** @class */ (function (_super) {
    __extends(RentersQuoteSummaryPanelWidget, _super);
    function RentersQuoteSummaryPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCoverDetails = function () {
            var interaction = _this.props.interaction;
            return (React.createElement(React.Fragment, null,
                React.createElement("h5", null, "Cover details"),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Price")),
                    React.createElement("div", { className: "text-blue-1 font-weight-bold" },
                        React.createElement("span", { id: "price" }, (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.premium)),
                        React.createElement("span", { className: "text-center font-weight-bold fs-16" },
                            " / month",
                            React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-3", title: "Pricing explained" }, (0, RentersPricingExplainedRenderers_1.renderRentersPricingExplained)(_this.props.interaction))))),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Cover start")),
                    React.createElement("div", null, moment(interaction.headerInfo.startDate).format("D MMMM YYYY"))),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Cover end")),
                    React.createElement("div", null, "Anytime")),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Contents cover limit")),
                    React.createElement("div", { id: "insuredValue" }, (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.insuredValue))),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Excess")),
                    React.createElement("div", { id: "excessAmount" },
                        "\u00A3",
                        interaction.factors.excessAmount)),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Accidental damage")),
                    React.createElement("div", { id: "accidentalDamageProtection" }, interaction.factors.accidentalDamageProtection ? "Included" : "Not included")),
                React.createElement("div", null,
                    React.createElement("a", { className: "link-edit", onClick: function () { return _this.navigateToEditCoverDetails(); } }, "Edit cover details"))));
        };
        _this.renderExtraCover = function () {
            var valuableItems = _this.props.interaction.valuableItems;
            if (valuableItems && valuableItems.length > 0) {
                var value = (0, commonFunctions_1.calculateValuablesTotalValue)(valuableItems);
                var items = valuableItems.map(function (item, index) {
                    return (React.createElement("div", { key: item.valuableItemId },
                        index !== 0 && React.createElement("div", { className: "dashed-10 my-4" }),
                        React.createElement("div", null, item.description),
                        item.coverLocation === services_1.ValuableItemCoverLocation.HOME ?
                            React.createElement("div", null,
                                React.createElement("b", null, "Cover inside the home"),
                                " for ",
                                React.createElement("b", null,
                                    "\u00A3",
                                    item.value)) :
                            React.createElement("div", null,
                                React.createElement("b", null, "Cover inside and outside the home"),
                                " for ",
                                React.createElement("b", null,
                                    "\u00A3",
                                    item.value)),
                        React.createElement("div", null,
                            "Monthly price: ",
                            React.createElement("b", null, (0, commonFunctions_1.getAmountToDisplay)(item.premium))),
                        React.createElement("div", { className: "d-flex justify-content-between justify-content-md-start mt-2 font-weight-medium text-blue-1 text-decoration-underline cursor-pointer" },
                            React.createElement("span", { className: "mr-4", onClick: function () { return _this.navigateToQuotePageForEditingValuableItems(); } }, "Edit"),
                            React.createElement("span", { onClick: function () { return _this.navigateToQuotePageForEditingValuableItems(); } }, "Remove"))));
                });
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "dashed-10-blue my-4" }),
                    React.createElement("h5", null, "Specified items"),
                    React.createElement("div", { className: "section text-left" },
                        React.createElement("p", null,
                            "You have added ",
                            React.createElement("b", { id: "valuableItemsCount" }, valuableItems.length),
                            " out of 10 items worth in total of ",
                            React.createElement("b", { id: "valuableItemsTotalValue" },
                                "\u00A3",
                                value)),
                        React.createElement.apply(React, __spreadArray(["div", { className: "mt-2 p-3 bg-white-blue rounded" }], items, false)))));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.renderPolicyHolderDetails = function () {
            var policyHolder = _this.props.interaction.policyHolder;
            var employmentStatus = policyHolder && policyHolder.employmentStatus ?
                _this.fetchLookupValue("employmentStatus", policyHolder.employmentStatus) : "";
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "dashed-10-blue my-4" }),
                React.createElement("h5", null, "Account holder details"),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        policyHolder.firstName,
                        " ",
                        policyHolder.lastName)),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Date of birth")),
                    React.createElement("div", null, moment(policyHolder.dateOfBirth).format("D MMMM YYYY"))),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Email")),
                    React.createElement("div", { className: "long-word" }, policyHolder.email)),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Employment status")),
                    React.createElement("div", { id: "employmentStatus" }, employmentStatus)),
                React.createElement("div", { className: "section" },
                    React.createElement("div", null,
                        React.createElement("b", null, "Claims in the last 5 years")),
                    React.createElement("div", { id: "claimsCount" }, policyHolder.claims && policyHolder.claims.length === 0 ? "None" : policyHolder.claims.length)),
                React.createElement("div", null,
                    React.createElement("a", { onClick: function () { return _this.navigateToEditAccountHolderDetails(); } }, "Edit account holder details"))));
        };
        _this.navigateToEditAccountHolderDetails = function () {
            _this.props.engine.navigate("personalDetails", false);
        };
        _this.navigateToEditOtherResidents = function () {
            _this.props.engine.navigate("otherResidents", false);
        };
        _this.navigateToEditPropertyDetails = function () {
            _this.props.engine.navigate("propertyDetails", false);
        };
        _this.navigateToQuotePageForEditingValuableItems = function () {
            _this.props.engine.setJourneyState({
                idToScrollTo: "coveredAnywhereSection"
            });
            _this.props.engine.navigate("quote", false);
        };
        _this.state = {
            showItemModal: false
        };
        return _this;
    }
    RentersQuoteSummaryPanelWidget.prototype.render = function () {
        return (React.createElement("div", { className: "renters-quote-summary-panel-widget panel" },
            this.renderCoverDetails(),
            this.renderExtraCover(),
            this.renderPolicyHolderDetails(),
            this.renderPropertyDetails(),
            this.renderOtherResidents()));
    };
    RentersQuoteSummaryPanelWidget.prototype.renderOtherResidents = function () {
        var _this = this;
        var realEstate = this.props.interaction.realEstates[0];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "dashed-10-blue my-4" }),
            React.createElement("h5", null, "Other residents"),
            React.createElement("div", { className: "section" },
                React.createElement("div", null,
                    React.createElement("b", null, "Adults over the age of 18")),
                React.createElement("div", { id: "otherResidentsAdults" }, this.getAdultsMessage(realEstate))),
            React.createElement("div", { className: "section" },
                React.createElement("div", null,
                    React.createElement("b", null, "Children under the age of 18")),
                React.createElement("div", { id: "otherResidentsChildren" }, realEstate.childrenAtProperty ? "Yes" : "No")),
            React.createElement("div", { className: "detail-value link-edit text-decoration-underline" },
                React.createElement("a", { onClick: function () { return _this.navigateToEditOtherResidents(); } }, "Edit other residents"))));
    };
    RentersQuoteSummaryPanelWidget.prototype.getAdultsMessage = function (realEstate) {
        var adults = "";
        if (realEstate.adultFamilyMemberCount) {
            if (realEstate.adultFamilyMemberCount === 1) {
                adults = realEstate.adultFamilyMemberCount + " family member and ";
            }
            else {
                adults = realEstate.adultFamilyMemberCount + " family members and ";
            }
        }
        else {
            adults = "No family members and ";
        }
        if (realEstate.housemateCount) {
            if (realEstate.housemateCount === 1) {
                adults += realEstate.housemateCount + " housemate";
            }
            else {
                adults += realEstate.housemateCount + " housemates";
            }
        }
        else {
            adults += " no housemates";
        }
        return adults;
    };
    RentersQuoteSummaryPanelWidget.prototype.renderPropertyDetails = function () {
        var _this = this;
        var realEstate = this.props.interaction.realEstates[0];
        var furnishingType = realEstate && realEstate.furnishingType ? this.fetchLookupValue("furnishingType", realEstate.furnishingType) : "";
        var realEstateTypeSubType = realEstate && realEstate.realEstateTypeSubType ? this.fetchLookupValue("realEstateTypeSubType", realEstate.realEstateTypeSubType).toLowerCase() : "";
        var bedroomsBathrooms = realEstate && realEstate.bathroomCount && realEstate.bedroomCount ?
            "with " + realEstate.bedroomCount + (realEstate.bedroomCount === 1 ? " bedroom and " : " bedrooms and ") +
                realEstate.bathroomCount + (realEstate.bathroomCount === 1 ? " bathroom" : " bathrooms") : "";
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "dashed-10-blue my-4" }),
            React.createElement("h5", null, "Property details"),
            React.createElement("div", { className: "section" },
                React.createElement("div", null,
                    React.createElement("b", null, "Insured address")),
                (0, CommonRenderers_1.getAddressToRender)(realEstate.address)),
            React.createElement("div", { className: "section" },
                React.createElement("div", null,
                    React.createElement("b", null, "Your property")),
                React.createElement("div", { className: "px-4", id: "propertyDetails" },
                    furnishingType,
                    " ",
                    realEstateTypeSubType,
                    " ",
                    bedroomsBathrooms),
                React.createElement("br", null),
                React.createElement("div", null,
                    React.createElement("a", { onClick: function () { return _this.navigateToEditPropertyDetails(); } }, "Edit property details")))));
    };
    RentersQuoteSummaryPanelWidget.prototype.navigateToEditCoverDetails = function () {
        this.props.engine.navigate("quote", false);
    };
    RentersQuoteSummaryPanelWidget.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], RentersQuoteSummaryPanelWidget.prototype, "lookupService", void 0);
    return RentersQuoteSummaryPanelWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=RentersQuoteSummaryPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/RentersQuoteSummaryPanelWidget.js
// module id = 2568
// module chunks = 0